var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-drawer',{staticClass:"mo-dashboard-drawer",attrs:{"md-permanent":"clipped"}},[_c('md-list',[_c('md-list-item',{attrs:{"to":"/dashboard"}},[_c('md-icon',[_vm._v("move_to_inbox")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Listings")])],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1db8030","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dashDrawer.vue
// module id = null
// module chunks = 